<ng-container *ngIf="showFooter">
  <div *ngIf="isTopSpacerEnabled" class="spacer"></div>

  <footer class="page-footer">
    <div *ngIf="subHeaderLinks.length" class="page-footer__top">
      <div class="container">
        <div class="sub-header-links">
          <ul class="sub-header-nav">
            <li *ngFor="let link of subHeaderLinks | orderBy : 'ordinal'; trackBy: trackByLinkTitle">
              <app-link
                [title]="link.title"
                [href]="link.href"
                [pagePath]="link.pagePath"
                [ariaLabel]="link.title"
                [linkTarget]="link.target"
                [additionalIcon]="link.iconName"
                [disableOpenNewTab]="true"
                [role]="LinkRoles.LINK"
                [customClass]="'Spa_Style_Smaller_Font text-decoration-none'"
                (click)="onClickSubHeaderLink(link)"
              >
              </app-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="page-footer__main">
      <div class="container">
        <div class="footer-links">
          <ul class="footer-nav">
            <li *ngFor="let link of footerLinks | orderBy : 'ordinal'; trackBy: trackByLinkTitle">
              <app-link
                [title]="link.title"
                [href]="link.href"
                [pagePath]="link.pagePath"
                [ariaLabel]="link.title"
                [linkTarget]="link.target"
                [alwaysUnderlined]="true"
                [disableOpenNewTab]="true"
                [role]="LinkRoles.LINK"
                (click)="onClickFooterLink(link)"
              >
              </app-link>
            </li>
          </ul>
        </div>

        <div class="row">
          <app-site-disclaimer class="col-12" [disclaimerConfig]="headerFooterDisclaimerText"></app-site-disclaimer>
        </div>

        <div *ngIf="showCopyright" class="row">
          <app-copyright class="col-12" [copyright]="copyright"></app-copyright>
        </div>

        <div *ngIf="footerCMSEnabled" class="row">
          <app-cms-approval-code
            class="col-12"
            [showMainCMS]="footerCMSEnabled"
            [CMS]="cmsApprovalCode"
            [showLastUpdated]="showLastUpdated"
            [lastUpdatedLabel]="lastUpdatedLabel"
          ></app-cms-approval-code>
        </div>

        <app-logo
          [logoConfig]="footerLogoProperties"
          [contentServerUrl]="contentServerUrl"
          [footerLogoAlternateText]="footerLogoAlternateText"
        ></app-logo>
      </div>
    </div>
  </footer>
</ng-container>
